import { NavigationMenuContent } from '@/components/NavigationMenu';
import { CtaLink } from '@/components/NewHeader/CtaLink';
import {
  CloseButton,
  DataList,
} from '@/components/NewHeader/NavBar/helperComponents';
import { useTranslation } from '@/contexts/dictionaryContext';
import useGTMEvents from '@/hooks/useGTMEvents';

export function Experiences() {
  const {
    newHeader: { experiences, nav },
  } = useTranslation();

  const { sendMenuClickEvent } = useGTMEvents();

  const section =
    nav.find((item) => item.id === 'experiences')?.title || 'Experiences';

  const handleItemClick = (item: { title: string; href: string }) =>
    sendMenuClickEvent({ section, sectionItem: item.title });

  return (
    <NavigationMenuContent className="w-full">
      <div className="grid grid-cols-[3fr_4fr] gap-4">
        <div className="bg-black/5 py-12 pl-24 pr-8 flex flex-col gap-6">
          <p className="uppercase font-bold">
            {experiences.foodExperiences.title}
          </p>
          <div className="grid grid-cols-2 gap-y-6">
            <div className="space-y-6">
              <DataList
                onItemClick={handleItemClick}
                key={experiences.foodExperiences.items[0].title}
                data={experiences.foodExperiences.items[0]}
              />
              <DataList
                onItemClick={handleItemClick}
                key={experiences.foodExperiences.items[1].title}
                data={experiences.foodExperiences.items[1]}
              />
            </div>

            <DataList
              onItemClick={handleItemClick}
              key={experiences.foodExperiences.items[2].title}
              data={experiences.foodExperiences.items[2]}
            />
          </div>

          <CtaLink
            onClick={() =>
              sendMenuClickEvent({
                section,
                sectionItem: experiences.cta.title,
              })
            }
            href={experiences.cta.href}
            className="mt-auto max-w-[280px] max-h-[64px]">
            {experiences.cta.title}
          </CtaLink>
        </div>

        <div>
          <div className="pt-12 pb-8 pl-12 pr-8 space-y-16">
            <div className="grid grid-cols-2 min-2xl:grid-cols-4 gap-y-12 gap-x-4 h-full">
              <div className="min-2xl:grid min-2xl:grid-rows-2 space-y-8">
                <DataList
                  onItemClick={handleItemClick}
                  data={experiences.privateTours}
                  smallContainer
                />
                <CtaLink
                  onClick={() =>
                    sendMenuClickEvent({
                      section,
                      sectionItem: experiences.privateTours.cta.title,
                    })
                  }
                  href={experiences.privateTours.cta.href}
                  className="max-w-[280px] max-h-[64px] self-end">
                  {experiences.privateTours.cta.title}
                </CtaLink>
              </div>
              <div>
                <DataList
                  onItemClick={handleItemClick}
                  data={experiences.privateTransfers}
                  smallContainer
                />
              </div>
              <div className="min-2xl:grid min-2xl:grid-rows-2 space-y-8">
                <DataList
                  onItemClick={handleItemClick}
                  data={experiences.outdoorActivities}
                  smallContainer
                />
                <CtaLink
                  onClick={() =>
                    sendMenuClickEvent({
                      section,
                      sectionItem: experiences.outdoorActivities.cta.title,
                    })
                  }
                  href={experiences.outdoorActivities.cta.href}
                  className="max-w-[280px] max-h-[64px] self-end">
                  {experiences.outdoorActivities.cta.title}
                </CtaLink>
              </div>
              <div className="min-2xl:grid min-2xl:grid-rows-2 space-y-8">
                <DataList
                  onItemClick={handleItemClick}
                  data={experiences.wineTours}
                  smallContainer
                />
                <CtaLink
                  onClick={() =>
                    sendMenuClickEvent({
                      section,
                      sectionItem: experiences.wineTours.cta.title,
                    })
                  }
                  href={experiences.wineTours.cta.href}
                  className="max-w-[280px] max-h-[64px] self-end">
                  {experiences.wineTours.cta.title}
                </CtaLink>
              </div>
            </div>
          </div>

          <div className="pb-2">
            <CloseButton />
          </div>
        </div>
      </div>
    </NavigationMenuContent>
  );
}
